import { createSelector } from "reselect"

const getAddins = (state: Addins.Addins): Addins.Addin[] => state.addins

export const getSortedAddins = createSelector(
    [getAddins],
    (addins): Addins.Addin[] =>
        addins.sort((a, b) =>
            a.addInName
                .toLocaleUpperCase()
                .localeCompare(b.addInName.toLocaleUpperCase()),
        ),
)
